import { isProviderOwnedAmbient, isProviderOwnedBackgrounds } from './providerOwnedImages'

// The movie edit form is loaded with merged cliMovie data, so a provider image
// can reach the submit even though it belongs in the provider store, never in
// pmMovie. This strips those again — but only when the slot is BOTH unchanged
// from what was loaded AND the provider's own value. The second condition is
// what keeps TMDB images alive: they also have id === null and are also
// unchanged on a save that never touched the images, so the first condition
// alone cannot tell them apart from a provider image.
const sanitizeMovieImages = (newMovieData, oldMovieData, candidates) => {
    const newImages = newMovieData.images
    const oldImages = (oldMovieData && oldMovieData.images) || {}

    if (newMovieData.logo !== null && newMovieData.logo && newMovieData.logo.id === null && !newMovieData.logo.url) {
        newMovieData.logo = null
    }

    if (newImages.poster !== null && newImages.poster.id === null && !newImages.poster.url) {
        newImages.poster = null
    }

    const ambientUnchanged = newImages.ambient !== null
        && newImages.ambient !== undefined
        && newImages.ambient.id === null
        && oldImages.ambient !== null
        && oldImages.ambient !== undefined
        && _.isEqual(newImages.ambient, oldImages.ambient)

    if (ambientUnchanged && isProviderOwnedAmbient(newImages.ambient, candidates)) {
        newImages.ambient = null
    }

    const newBackgrounds = newImages.backgrounds
    const oldBackgrounds = oldImages.backgrounds

    if (newBackgrounds && oldBackgrounds && newBackgrounds.length === oldBackgrounds.length) {
        const backgroundsUnchanged = newBackgrounds.every((item, index) => _.isEqual(item, oldBackgrounds[index]))

        // Kept from the original: filter to id !== null rather than assigning
        // [] directly. isProviderOwnedBackgrounds only compares urls, so it
        // cannot rule out a WP-uploaded entry sharing a url with a provider
        // entry — the per-item id check is what actually protects uploads.
        if (backgroundsUnchanged && isProviderOwnedBackgrounds(newBackgrounds, candidates)) {
            newImages.backgrounds = newBackgrounds.filter(item => item.id !== null)
        }
    }

    return newMovieData
}

export default sanitizeMovieImages
